module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/qrcode/qrcode.component.css
// module id = ./src/app/qrcode/qrcode.component.css
// module chunks = main